<template>
    <v-navigation-drawer
      v-model="sideMenuDrawer"  
      fixed  app :clipped="$vuetify.breakpoint.lgAndUp"> 
      <v-list>
        
         <v-list-group
          prepend-icon="fas fa-layer-group"
         
        >
            <v-list-tile slot="activator">
            <v-list-tile-title>Hierarchy</v-list-tile-title>
            </v-list-tile>

        <v-list-tile @click="$router.push('/productType')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-bullseye</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Product Type</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="$router.push('/sbu')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-braille</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>SBU</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="$router.push('/brand')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">map</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Brand</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="$router.push('/category')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-book</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Category</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="$router.push('/category')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-sitemap</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Sub Category</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="$router.push('/markFor')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-user-tag</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Mark For</v-list-tile-title>
        </v-list-tile>
         </v-list-group>
 <v-divider> </v-divider>
  <v-list-group
          prepend-icon="fas fa-fire-alt"
          
        >
            <v-list-tile slot="activator">
            <v-list-tile-title>Attribute</v-list-tile-title>
            </v-list-tile>
        
            <v-list-tile @click="$router.push('/sizeChart')">
              <v-list-tile-action>
                <v-icon   color="dark-grey" >fas fa-signal</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Size Chart</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/color')">
              <v-list-tile-action>
                <v-icon   color="dark-grey" >fas fa-palette</v-icon>
                
              </v-list-tile-action>
              <v-list-tile-title>Colors</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/attribute')">
              <v-list-tile-action>
                <v-icon   color="dark-grey" >fas fa-th-list</v-icon>
                
              </v-list-tile-action>
              <v-list-tile-title>Attributes</v-list-tile-title>
            </v-list-tile>
            
            
            
       </v-list-group>

<v-divider> </v-divider>
 <v-list-tile @click="$router.push('/season')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-cloud-moon-rain</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Seasons</v-list-tile-title>
        </v-list-tile>
      
       <v-list-tile @click="$router.push('/style')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-leaf</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Styles</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="$router.push('/mwsProductFulfillment')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-boxes</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Inventory</v-list-tile-title>
        </v-list-tile>
        

 <v-divider> </v-divider>
       <v-list-tile @click="$router.push('/catalog')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-icons</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Catalogs</v-list-tile-title>
        </v-list-tile>


       <v-list-tile @click="$router.push('/warehouse')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-building</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Warehouse</v-list-tile-title>
        </v-list-tile>
       <v-list-tile @click="$router.push('/supplier')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">fas fa-users</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Supplier</v-list-tile-title>
        </v-list-tile>
 <v-divider> </v-divider>
       <v-list-tile @click="$router.push('/reportSubscriptions')">
              <v-list-tile-action >
                <v-icon class="dark-grey--text">far fa-list-alt</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>My Reports</v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-group
          prepend-icon="build"
          
        >
            <v-list-tile slot="activator">
            <v-list-tile-title>Settings</v-list-tile-title>
            </v-list-tile>
        
            <v-list-tile @click="$router.push('/workFlow')">
              <v-list-tile-action>
                <v-icon   color="dark-grey" >fas fa-balance-scale</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Business Rules</v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                 <v-icon   color="dark-grey">fas fa-user</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Preferences</v-list-tile-title>
            </v-list-tile>
            
       </v-list-group>
        
            <v-list-group
          prepend-icon="fas fa-user-graduate"
          
          
        >
            <v-list-tile slot="activator">
              <v-list-tile-title>Admin</v-list-tile-title>
            </v-list-tile>
           <v-list-tile @click="$router.push('/users')">
              <v-list-tile-action>
                 <v-icon   color="dark-grey">fas fa-user</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Users</v-list-tile-title>
            </v-list-tile>
             <v-list-tile>
           <v-list-tile-action>
                  <v-icon>verified_user</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Roles</v-list-tile-title>
            </v-list-tile>
         <v-list-tile @click="$router.push('/shipper')">
          <v-list-tile-action>
            <v-icon   color="dark-grey" >fas fa-truck</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Shippers</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="$router.push('/fulfillment')">
          <v-list-tile-action>
            <v-icon   color="dark-grey" >fas fa-warehouse</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Fullfilments</v-list-tile-title>
        </v-list-tile>
            
             <v-list-tile @click="$router.push('/upload')">
              <v-list-tile-action>
                <v-icon   color="dark-grey" >fas fa-square</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Upload</v-list-tile-title>
            </v-list-tile>
        </v-list-group>
        <v-divider> </v-divider>
        <v-list-tile>
          <v-list-tile-action>
          <v-icon color="dark-grey" >fas fa-sign-out-alt</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
</template>
  <script>


export default{
    props:[
      'sideMenuDrawer'
    ],
  data()  { 
      
      return {
       
      }
},
}
</script>
<style lang="scss">
.list-tile-title {
  font-size:12px;
}
</style>